import {lazyRegister} from '@/Core/lazyRegister';
import './lazy-scroll-into-view.component.css';
import template from './lazy-scroll-into-view.component.html';

class LazyScrollIntoViewController {
    static $inject = ['$element', '$timeout'];
    delay: number = 200;
    onVisible: Function;

    private observer: IntersectionObserver | null = null;
    private isVisible: boolean = false;
    private debounceLoadMoreTimer: any = null;

    constructor(
        private $element: ng.IRootElementService,
        private $timeout: ng.ITimeoutService
    ) {
    }

    $onInit(): void {
        this.$element.addClass('lazy-scroll-into-view');
        if (this.delay === undefined) this.delay = 200;
        this.setupIntersectionObserver();
    }

    private setupIntersectionObserver(): void {
        const options: IntersectionObserverInit = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.cancelTimer();

                    // wait some time
                    this.debounceLoadMoreTimer = this.$timeout(() => {
                        this.onElementVisible();
                    }, this.delay);
                } else {
                    // scroll pass this block, stop rendering
                    this.cancelTimer();
                }
            });
        }, options);

        this.observer.observe(this.$element[0]);
    }

    private onElementVisible(): void {
        this.disconnectObserver();
        this.$element.addClass('visible'); // display: contents
        this.isVisible = true;
        if (this.onVisible) {
            this.onVisible();
        }
    }

    private cancelTimer(): void {
        if (this.debounceLoadMoreTimer) {
            this.$timeout.cancel(this.debounceLoadMoreTimer);
            this.debounceLoadMoreTimer = null;
        }
    }

    private disconnectObserver(): void {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    $onDestroy(): void {
        this.cancelTimer();
        this.disconnectObserver();
    }
}

export const LazyScrollIntoViewComponent: ng.IComponentOptions = {
    transclude: true,
    bindings: {
        delay: '<?',
        loadingType: '@?',
        loadingClass: '@?',
        onVisible: '&?'
    },
    template: template,
    controller: LazyScrollIntoViewController
};

lazyRegister.component('lazyScrollIntoView', LazyScrollIntoViewComponent);